import Vue from "vue";
import Vuex from "vuex";
import {
	userLogin,
	userLogOut,
	userInfo,
	getCandidatePrimaryProfile,
	getCandInfo,
	getProfileCompletion,
	getNotificationData,
	getDeviceActivity,
	clearNotification,
} from "../../utils/apiFunctions.js";
import router, { resetRouter } from "../../router";
import {
	clearCookies,
	setRefreshToken,
	clearGuestUUID,
	setToken,
	getRefreshToken,
	getToken,
	logoutRedirect,
	getMobileToken,
} from "../../utils/tokenCheck";
import store from "../index.js";
import jwt_decode from "jwt-decode";
import { COOKIE_OPTIONS_SUFFIX } from "@/utils/cookieConfig.js";
import { Capacitor } from "@capacitor/core";

export const getCurrentRouteName = () => {
	return router.currentRoute.name;
}
import EventBus from "@/utils/EventBus";
import { clearSessionTrackedEvents } from "@/utils/posthogHelpers.js";
import { flushAll as flushAllTracking } from "@/tracking/tracker";
const qs = require("qs");
// import axios from "axios";
Vue.use(Vuex);

const initialState = () => ({
	resumeClinic_uuid: null,
	resumeClinic_Jobid: null,
	userInfo: {},
	showMenu: false,
	licenseKey: "",
	token: "",
	refreshToken: "",
	loggedin: true,
	roleValues: {},
	roles: [],
	userName: "",
	userEmail: "",
	showpref: false,
	selectedTheme: "",
	pageTitle: { titleName: "Dashboard", path: "/dashboard" },
	promoData: null,
	userData: {},
	newUserUsingUUID: false,
	notificationRedirect: null,
	// candidateProgress : null,
	candAccess: false,
	unreadCount: 0,
	notificationCount: 0,
	newUseruuid: null,
	resumeClinic: false,
	downloadReport: false,
	showResumeClinic: false,
	onboardingCompleted: true,
	isFirstTimeUser: false,
});

// State
const state = initialState;

// getters
const getters = {
	getNotificationRedirect: (state) => state.notificationRedirect,
	getUserInfo: (state) => state.userInfo,
	getShowPref: (state) => state.showpref,
	getlicenseKey: (state) => state.licenseKey,
	getUserName: (state) => state.userName,
	getMenuStatus: (state) => state.showMenu,
	getUserEmail: (state) => state.userEmail,
	getPageTitle: (state) => state.pageTitle,
	getSelectedTheme: (state) => state.selectedTheme,
	getToken: (state) => state.token,
	getUserRefreshToken: (state) => state.refreshToken,
	getPromoData: (state) => state.promoData,
	getResumeUiid: (state) => state.resumeClinic_uuid,
	getResumejobid: (state) => state.resumeClinic_Jobid,
	getUserData: (state) => state.userData,
	getCandAccess: (state) => state.candAccess,
	getUnreadCount: (state) => state.unreadCount,
	getNotificationCount: (state) => state.notificationCount,
	getNewUseruuid: (state) => state.newUseruuid,
	getResumeClinic: (state) => state.resumeClinic,
	getDownloadReport: (state) => state.downloadReport,
	getShowResumeClinic: (state) => state.showResumeClinic,
	getOnboardingCompleted: (state) => state.onboardingCompleted,
	getIsFirstTimeUser: (state) => state.isFirstTimeUser,
};

// actions
const actions = {
	// http://sso.simplifycv.com/
	// https://auth.hire3x.com/
	// Login Api

	Login({ commit }, userInfo) {
		commit("setUserDetails", userInfo);

		return new Promise((resolve, reject) => {
			userLogin(userInfo.keycloak, {
				"content-type": "application/x-www-form-urlencoded;charset=utf-8",
			})
				.then(async (response) => {
					const data = response.data;
					if (data.access_token) {
						setToken(data.access_token);
						if (data.refresh_token) {
							setRefreshToken(data.refresh_token);
						}
						commit("SET_TOKEN", data.access_token);
						commit("SET_REFRESH_TOKEN", data.refresh_token);
						const decoded = jwt_decode(data.access_token);
						let candData = {
							isActive: true,
							project: "candidate",
							userPermissions: { isActive: true },
						};
						document.cookie = `candidate=${JSON.stringify(
							candData
						)}; ${COOKIE_OPTIONS_SUFFIX}`;
						// commit("SET_USER_NAME", decoded.given_name);
						if (!userInfo.callSetCandAccess) {
							commit("setCandAccess", true);
						}

						resolve(response);
					} else {
						reject(data);
					}
				})
				.catch((error) => {
					reject(error);
				});
		});
	},

	// http://sso.simplifycv.com/
	// https://auth.hire3x.com/
	// LogOut Api
	LogOut({ commit, dispatch }) {
		resetRouter();
		userLogOut(
			qs.stringify({
				client_id: Capacitor.isNativePlatform() ? "hire3x-app" : "vue-test-app",
				refresh_token: getRefreshToken(),
			}),
			{
				"content-type": "application/x-www-form-urlencoded;charset=utf-8",
				Authorization: `Bearer ${getToken()}`,
			}
		)
			.then(async (response) => {
				if (Capacitor.isNativePlatform() && getMobileToken()) {
					try {
						await clearNotification({ token: getMobileToken() });
					} catch (error) {
						console.log("Error clearing notification:", error);
					}
				}
				dispatch("clearAllVuex");
				clearCookies();
				clearGuestUUID(); // Clear guest UUID on logout
				localStorage.clear();
				clearSessionTrackedEvents();
				if (localStorage.getItem("currentPage") != "ViewPublicProfile" && getCurrentRouteName() != "IdCapture") {
					logoutRedirect()
					// location.replace("http://localhost:8080/login?from=admin");
					// window.location.replace(url);
				} else if (localStorage.getItem("refresh")) {
					window.location.reload();
				}
				// alert("User Logged Out");
			})
			.catch(async (error) => {
				if(Capacitor.isNativePlatform() && getMobileToken()) {
					try {
						await clearNotification({ token: getMobileToken() });
					} catch (error) {
						console.log("Error clearing notification:", error);
					}
				}
				dispatch("clearAllVuex");
				clearCookies();
				clearGuestUUID(); // Clear guest UUID on logout error
				console.error(error);
				localStorage.clear();
				clearSessionTrackedEvents();
				if (localStorage.getItem("currentPage") != "ViewPublicProfile" && getCurrentRouteName() != "IdCapture") {
					logoutRedirect()
					// location.replace("http://localhost:8080/login?from=admin");
					// window.location.replace(url);
				} else if (localStorage.getItem("refresh")) {
					window.location.reload();
				}
			});
	},

	clearAllVuex({ commit }, payload = {}) {
		// Send pending tracking events before the user is cleared.
		flushAllTracking();
		commit("RESET_STATE", payload);
		store.commit("candidateVUEX/RESET_STATE", null, { root: true });
		localStorage.removeItem("simpAdminState");
	},

	async fetchUnreadCount({ commit, state }) {
		if (!state.token) return;
		try {
			const payload = {
				userID: state.userInfo.userID,
				count: 1,
				page: 0,
				order: -1,
			};
			const res = await getNotificationData(payload);
			if (res.status === 200) {
				commit("setUnreadCount", res.data.data.totalUnreadCount);
				commit("setNotificationCount", res.data.data.totalCount);
			}
		} catch (err) {
			console.error("Failed to fetch unread count:", err);
		}
	},

	async fetchPostLoginData({ commit, dispatch }, onboarding) {
		try {
			const res = await userInfo();
			if (res.status === 200) {
				commit("setUserInfo", res.data.data);
			}

			const respData = await getCandidatePrimaryProfile();
			if (respData.status === 200) {
				commit("candidateVUEX/setPrimaryProfile", respData.data.data, {
					root: true,
				});
			}

			const resp = await getCandInfo();
			if (resp.status === 200) {
				const candidateInfo = resp.data.data;
				commit("candidateVUEX/setCandidateInfo", candidateInfo, { root: true });

				const res2 = await getProfileCompletion();
				if (res2.status === 200) {
					const candProgressResp = res2.data.data;
					commit("candidateVUEX/updateCandidateProgress", candProgressResp, {
						root: true,
					});
					if (candidateInfo.primary) {
						commit(
							"candidateVUEX/updateCandidateProgressPrimary",
							candProgressResp,
							{ root: true }
						);
					}
				}
			}
			await dispatch("fetchUnreadCount");
			await dispatch("loginToSocket");
			if (onboarding) EventBus.$emit("onboarding-fetch-post-login");
		} catch (error) {
			console.error("Error fetching post-login data:", error);
		}
	},

	async loginToSocket({ state }) {
		try {
			const response = await getDeviceActivity();
			const device = response.data;

			device.forEach((deviceItem) => {
				const sessions = deviceItem.sessions;

				const currentIndex = sessions.findIndex(
					(item) => item.current === true
				);

				if (currentIndex !== -1) {
					const objectWithCurrentKey = sessions[currentIndex];

					const userid = objectWithCurrentKey.id;
					localStorage.setItem("currentLogin", userid);
					const email = state.userInfo.email;
					localStorage.setItem("currentEmail", email);
					if (Vue.prototype.$socket) {
						Vue.prototype.$socket.emit("signIn", {
							email: email,
							userid: userid,
						});
					}
				}
			});
		} catch (error) {
			console.error("Error in loginToSocket:", error);
		}
	},
};

// mutations
const mutations = {
	setNotificationRedirect(state, data) {
		state.notificationRedirect = data;
	},
	setNewUseruuid(state, uuid) {
		state.newUseruuid = uuid;
	},
	RESET_STATE(state, payload = {}) {
		const { keepFlowData = false } = payload;
		const defaults = initialState();
		if (keepFlowData) {
			const flowData = {
				userData: state.userData,
				candAccess: state.candAccess,
				resumeClinic_uuid: state.resumeClinic_uuid,
				resumeClinic_Jobid: state.resumeClinic_Jobid,
				downloadReport: state.downloadReport,
				showResumeClinic: state.showResumeClinic,
			};
			Object.assign(state, defaults, flowData);
		} else {
			Object.assign(state, defaults);
		}
	},
	SET_RESUME_UUID(state, resumeClinic_uuid) {
		state.resumeClinic_uuid = resumeClinic_uuid;
	},
	setresumeJobid(state, jobId) {
		state.resumeClinic_Jobid = jobId;
	},
	setUserInfo(state, payload) {
		state.userInfo = payload;
	},
	setUserInfoisDisabled(state, payload) {
		state.userInfo.isDisabled = payload;
	},
	setSelectedTheme(state, payload) {
		state.selectedTheme = payload;
	},

	setUserDetails(state, payload) {
		state.userEmail = payload;
	},
	// TOGGLE MENU SIDE BAR
	setMenuStatus(state, payload) {
		state.showMenu = payload;
	},
	SET_USER_NAME(state, userName) {
		state.userName = userName;
	},
	// Storing Roles Value
	SET_ROLES(state, roles) {
		state.roles = roles;
	},
	// Storing LicenseKey
	saveLicenseKey(state, payload) {
		state.licenseKey = payload;
	},
	// Storing User Role & Access Values
	getRoleValue(state, payload) {
		state.roleValues = payload;

		// state.roles = payload.roles;
	},
	// Storing Token
	SET_TOKEN(state, token) {
		state.token = token;
	},
	// Storing Refresh Token
	SET_REFRESH_TOKEN(state, refreshToken) {
		state.refreshToken = refreshToken;
	},
	setPageTitle(state, newTitle) {
		state.pageTitle = newTitle;
	},
	setPromoData(state, payload) {
		state.promoData = payload;
	},
	// setUpdateProgress(state, value) {
	//   state.candidateProgress = value;
	// },
	setUserData(state, payload) {
		state.userData = payload;
	},
	setNewUserUsingUUID(state, payload) {
		state.newUserUsingUUID = payload;
	},
	setresumeClinicuid(state, payload) {
		state.resumeClinic_uuid = payload;
	},

	setCandAccess(state, payload) {
		state.candAccess = payload;
	},
	setUnreadCount(state, payload) {
		state.unreadCount = payload;
	},
	setNotificationCount(state, payload) {
		state.notificationCount = payload;
	},
	setResumeClinic(state, payload) {
		state.resumeClinic = payload;
	},
	setDownloadReport(state, payload) {
		state.downloadReport = payload;
	},
	setShowResumeClinic(state, payload) {
		state.showResumeClinic = payload;
	},
	setOnboardingCompleted(state, payload) {
		state.onboardingCompleted = payload;
	},
	setIsFirstTimeUser(state, payload) {
		state.isFirstTimeUser = payload;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
